export default __webpack_public_path__ + "static/01-6be00fe502405b60e29e2077d941c093.jpg";